import { ApiConfig } from 'common/models/api-service/api-config.model';

const downloadTemplateConfig = {
    getDownloadUrl: (): ApiConfig => new ApiConfig(`Storage/download?path=CoreTemplate`, 'POST')
};

export default downloadTemplateConfig;
